/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Editovat",
  "i18n.actionBar.removeImage": "Odstranit",
  "i18n.actionBar.swapImage": "Nahradit",
  "i18n.additionalInfoItemLayers.smartSorted.new": " Nové! ",
  "i18n.additionalProducts.addToCart": "Přidat k objednávce",
  "i18n.additionalProducts.frame.description": "Odolný Hliníkový rámeček: Matný stříbrný odstín, kvalitní sklo, bez lepidla – není potřeba",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tip:",
  "i18n.additionalProducts.frame.subtitle": "Složené puzzle je krásnou památkou – v našem <b>rámečku</b> skvěle vynikne.",
  "i18n.additionalProducts.frame2023.description": "Odolný Skládací rámeček z kvalitního dřevovláknitého materiálu – snadné sestavení, bez skla, včetně Lepidla na puzzle",
  "i18n.additionalProducts.framePlastic.description": "Odolný Hliníkový rámeček: Matný stříbrný odstín, ochranné umělé sklo s antireflexní vrstvou, bez lepidla - není potřeba",
  "i18n.additionalProducts.glue.description": "Vystačí až na dvoje puzzle 1000 dílků, včetně nanášecí houbičky",
  "i18n.additionalProducts.glue.hook": "Z vašich puzzle se stane obrázek.\nPuzzle trvale slepí a chrání.",
  "i18n.additionalProducts.roll.description": "Vhodná pro puzzle 48 - 2000 dílků",
  "i18n.additionalProducts.roll.hook": "Nemáte volný stůl? Žádný problém.\nPuzzle srolujte, uložte do skříně a pokračujte později.",
  "i18n.adventCalendarOverlay.activate": "Zobrazit náhled 24 okének",
  "i18n.adventCalendarOverlay.deactivate": "Vypnout náhled 24 okének",
  "i18n.adventCalendarOverlay.notice": "(Čísla a čáry se nevytisknou)",
  "i18n.button.addToCart": "Vložit do košíku",
  "i18n.button.apply": "Potvrdit",
  "i18n.button.back": "Zpět",
  "i18n.button.cancel": "Storno",
  "i18n.button.cancelAndFix": "Změnit teď",
  "i18n.button.chooseSmartSorted": "SMART SORTED",
  "i18n.button.close": "Zavřít",
  "i18n.button.continue": "Pokračovat",
  "i18n.button.createNewTextPlaceholders": "Zadat text",
  "i18n.button.ignore": "Storno",
  "i18n.button.ignoreAndContinue": "Přesto pokračovat",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Bez SMART SORTED",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Fotografie",
  "i18n.button.retry": "Obnovit",
  "i18n.button.uploadPhotos": "Nahrát fotografii(e)",
  "i18n.button.withSmartSorted": "SMART SORTED",
  "i18n.button.withoutSmartSorted": "Bez SMART SORTED",
  "i18n.control.colorChooser.color": "Barva",
  "i18n.control.fontChooser.placeholderText": "Typ písma",
  "i18n.control.imageQuality.checkImages": "Zkontrolujte rozlišení fotografie",
  "i18n.control.imageQuality.imageSuitability": "Kvalita fotografie:",
  "i18n.control.imageQuality.indicatorAltText": "Kvalita fotografie",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Vyberte rozvržení",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pro lepší čitelnost zkraťte prosím text.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Vybraný typ písma je příliš dlouhý pro tento text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Byla dosažena maximální možná velikost písma.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Byla dosažena minimální možná velikost písma.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Prosím vložte zalomení textu",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Pokračujte v psaní na další řádek nebo zvětšete textové pole.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Zkontrolujte zadaný text. Toto písmo nepodporuje všechny znaky.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Bylo dosaženo maximálního počtu znaků",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pro lepší čitelnost zkraťte prosím text.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "prosím zvětšete textové pole",
  "i18n.dialog.deletePlaceholder.message": "Tento krok nelze udělat zpětně",
  "i18n.dialog.deletePlaceholder.title": "Opravdu smazat?",
  "i18n.dialog.error.title": [
    "Vyskytla se chyba.",
    "Vyskytly se chyby.",
    "Vyskytly se chyby."
  ],
  "i18n.dialog.insufficientImageQuality.message": "Rozlišení této fotografie je příliš nízké na to, aby se fotografie vytiskla ostře a detailně!",
  "i18n.dialog.smartSorted.message": "Se SMART SORTED složíte bez námahy Váš motiv s 1000 dílky, a to i bez  předlohy",
  "i18n.dialog.smartSorted.title": "Úspěch zaručen",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Pro změnu textu na krabičce klikněte prosím na \"{{text}}\".",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Text na krabičce nebyl změněn",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Pokračovat bez textu na krabičce",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Fotografii vložíte kliknutím na symbol obrázku",
    "Fotografie vložíte kliknutím na symboly obrázků",
    "Fotografie vložíte kliknutím na symboly obrázků"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Nebyla vložena jedna fotografie",
    "Nebylo vloženo více fotografií",
    "Nebylo vloženo více fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Nebyla nahrána fotografie.",
    "Nebylo nahráno více fotografií.",
    "Nebylo nahráno více fotografií."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Kliknutím na fotografii a kolonku s textem změníte koláž",
    "Kliknutím na fotografii a kolonku s textem změníte koláž",
    "Kliknutím na fotografii a kolonku s textem změníte koláž"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Nebylo nahráno více fotografií",
    "Nebylo nahráno více fotografií",
    "Nebylo nahráno více fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Pro změnu textu klikněte prosím na kolonku s textem",
    "Pro změny textů klikněte prosím na kolonky s textem",
    "Pro změny textů klikněte prosím na kolonky s textem"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Kolonka s textem nebyla změněna",
    "Kolonky s texty nebyly změněny",
    "Kolonky s texty nebyly změněny"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Chybějící fotografie",
  "i18n.error.additionalInfoItemsError.message": "Chyba při načítání informační vrstvy",
  "i18n.error.additionalInfoItemsError.title": "Chyba při načítání",
  "i18n.error.deprecatedBrowserError.message": "Prohlížeč, který používáte, už není podporovaný. Aktualizujte ho prosím na novější verzi.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Návrhu jste se delší dobu nevěnovali, proto ho nelze dokončit. Začněte prosím od začátku. ",
  "i18n.error.designerExpiredError.title": "Návrh byl dokončený. ",
  "i18n.error.fontLoadingError.message": "Písmo nelze načíst",
  "i18n.error.fontLoadingError.title": "Chyba při načítání",
  "i18n.error.imageLoadingError.message": "Fotografie nemohla být nahrána. Byla odstraněna z galerie a z plochy.",
  "i18n.error.imageLoadingError.title": "Chyba stahování",
  "i18n.error.imageProvisionError.message": "Jedna nebo více fotografií nemohlo být zpracováno. Pravděpodobně nejsou v podporovaném formátu.",
  "i18n.error.imageProvisionError.title": "Fotografie nemohla být zpracována",
  "i18n.error.imageSelectionError.message": "Soubor \"{{reference1}}\" nemohl být zpracován",
  "i18n.error.imageSelectionError.title": "Chyba během nahrávání fotografie",
  "i18n.error.imageSizeLimitExceededError.message": "Nahraný obrázek je příliš velký.\nZmenšete ho prosím na méně než 180 megapixelů a zkuste ho nahrát znovu.",
  "i18n.error.imageSizeLimitExceededError.title": "Chyba během nahrávání fotografie",
  "i18n.error.imageUploadError.message": "Vyskytla se chyba v internetovém připojení. Prosím zkuste to znovu později.",
  "i18n.error.imageUploadError.title": "Chyba během nahrávání fotografie",
  "i18n.error.inlineSVGLoadingError.message": "Chyba načítání stránky při vytváření produktu \"{{reference1}}\"",
  "i18n.error.inlineSVGLoadingError.title": "Chyba stahování",
  "i18n.error.invalidCharConfigError.message": "Tento typ písma nelze použít, vyberte prosím jiný",
  "i18n.error.invalidCharConfigError.title": "Typ písma není použitelné",
  "i18n.error.malformedProductError.message": "Jeden nebo více produktů nebyly načteny. Je možné, že výrobek již není k dispozici nebo vytváření trvalo moc dlouho. Je nám to moc líto. Začněte, prosím, nové vytváření produktu.",
  "i18n.error.malformedProductError.title": "Chyba při načítání",
  "i18n.error.notInStockError.message": "Vámi vybraný výrobek není momentálně k dispozici.\nKliknutím na naše logo vlevo nahoře přejdete na domovskou stránku, kde si můžete vybrat jiný výrobek.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Zdá se, že Vaše internetové připojení bylo přerušeno. S vytvářením produktu můžete pokračovat hned, jakmile bude obnoveno.",
  "i18n.error.templateLoadingError.message": "Šablona \"{{ error.reference[0] }}\" nemohla být nahrána.\nProsím zkuste to později.",
  "i18n.error.templateLoadingError.title": "Chyba stahování",
  "i18n.error.transformationError.message": "Změnu nelze provést",
  "i18n.error.transformationError.title": "Vyskytla se chyba  ",
  "i18n.error.traudlLoadingError.message": "Zkuste to prosím znovu nebo vyberte jinou fotku.",
  "i18n.error.traudlLoadingError.title": "Filter AI sa nepodarilo použiť. ",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" je v nepodporovaném formátu.",
  "i18n.error.unsupportedMediaTypeError.title": "Chyba během nahrávání fotografie",
  "i18n.error.uploadProductError.message": "Jeden nebo několik produktů nebylo přeneseno na server.\nProsím zkuste to znovu později.",
  "i18n.error.uploadProductError.title": "Chyba přenosu.",
  "i18n.error.zoomModeError.message": "Váš text z předchozího návrhu nelze převzít. Zadejte prosím nový text.",
  "i18n.error.zoomModeError.title": "Text nebyl přijat",
  "i18n.gallery.uploadPhotos.info": "Prosím klikněte na tlačítko \"Nahrát fotografii(e)\"",
  "i18n.gallery.uploadProgress": [
    "Nahrávání fotografie ...",
    "Fotografie nahrány: {{current}} z {{total}}",
    "Fotografie nahrány: {{current}} ze {{total}}"
  ],
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Ušetříte",
  "i18n.price.total": "Celková cena",
  "i18n.priceDisplay.times": [
    "{{value}} kus za {{pricePerUnit}}",
    "{{value}} kusy každý za {{pricePerUnit}}",
    "{{value}} kusů každý za {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Příslušenství (volitelné)",
  "i18n.progressOverlay.message.lines.one": "Děkujeme za vytvoření tohoto hezkého výrobku.",
  "i18n.progressOverlay.message.lines.two": "Vše pro Vás připravíme...",
  "i18n.template.insertText": "Zde zadejte text",
  "i18n.toolbox.gallery.title": "Vyberte fotografie",
  "i18n.toolbox.image.title": "Úprava fotografie",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 fotka",
    "{{value}} fotky",
    "{{value}} fotek"
  ],
  "i18n.toolbox.layout.title": "Změna rozvržení",
  "i18n.toolbox.layout.triggerText": "Rozvržení",
  "i18n.toolbox.preview.title": "3D náhled",
  "i18n.toolbox.productChooser.title": "Změna produktu",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Upravit text"
};


export class LocaleCsCZ {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
